<form [formGroup]="form">
  <div class="grid grid-cols-1 gap-x-4 md:grid-cols-2">
    <mat-form-field class="flex-1">
      <mat-label>
        @if (isFirst) {
          <span>Primary </span>
        }
        <span>Contact Number</span>
        @if (index !== 0) {
          <span> {{ index + 1 }}</span>
        }
      </mat-label>
      <input
        [required]="isRequired$ | async"
        matInput
        formControlName="number"
      />
      <mat-hint *ngIf="isFirst">
        Default number used when contacting the patient
      </mat-hint>
    </mat-form-field>
    <div class="flex-1">
      <mat-form-field fxFlex>
        <mat-label>Label</mat-label>
        <input matInput formControlName="label" [matAutocomplete]="auto" />
        <div
          matSuffix
          class="controls"
          (click)="$event.stopImmediatePropagation()"
        >
          <ng-content />
        </div>
      </mat-form-field>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option
          *ngFor="
            let option of filteredOptions$ | async;
            trackBy: trackByOption
          "
          [value]="option"
        >
          {{ option }}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
</form>
